import { useEventsArchive } from '@/api/queries';
import { useAuthStore } from '@/store/authStore';
import { useUIStore } from '@/store/uiStore';
import { EventItem } from './EventItem';
import { haptic } from '@/lib/telegram';

export function ArchiveOverlay() {
  const userId = useAuthStore((s) => s.userId);
  const open = useUIStore((s) => s.isModalOpen('archive'));
  const closeModal = useUIStore((s) => s.closeModal);
  const page = useUIStore((s) => s.archivePage);
  const setPage = useUIStore((s) => s.setArchivePage);
  const { data, isLoading } = useEventsArchive(userId, page, 20);

  if (!open) return null;

  const totalPages = data?.total_pages ?? 1;
  const events = data?.events ?? [];

  const handleClose = () => {
    haptic('light');
    closeModal('archive');
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-3"
      onClick={handleClose}
    >
      <div
        className="bg-bg-surface rounded-2xl w-full max-w-[500px] max-h-[90vh] flex flex-col overflow-hidden border border-white/10"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">Архив событий</h2>
          <button
            onClick={handleClose}
            className="text-white/60 hover:text-white text-xl px-2 leading-none"
            aria-label="Закрыть"
          >
            ✕
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-3">
          {isLoading && (
            <div className="text-white/40 text-center py-10">Загружаем…</div>
          )}
          {!isLoading && events.length === 0 && (
            <div className="text-white/40 text-center py-10 italic">
              Пусто.
            </div>
          )}
          {events.map((e) => (
            <EventItem key={e.id} event={e} />
          ))}
        </div>

        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-2 px-3 py-3 border-t border-white/10">
            <button
              onClick={() => {
                haptic('light');
                setPage(Math.max(1, page - 1));
              }}
              disabled={page <= 1}
              className="px-4 py-2 rounded-lg bg-white/10 text-white text-sm disabled:opacity-50 hover:bg-white/15"
            >
              ◀ Назад
            </button>
            <span className="text-white/60 text-sm tabular-nums px-2">
              {page} / {totalPages}
            </span>
            <button
              onClick={() => {
                haptic('light');
                setPage(Math.min(totalPages, page + 1));
              }}
              disabled={page >= totalPages}
              className="px-4 py-2 rounded-lg bg-white/10 text-white text-sm disabled:opacity-50 hover:bg-white/15"
            >
              Вперёд ▶
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
